import ModuleTypeEnum from '../enums/ModuleTypeEnum';
import configureStore from './../store/store';

const store = configureStore();

class ModuleHelper {
    static get = (id) => store.getState().module?.list.find(module => module.id === id);
    static select = (id) => store.dispatch({ type: 'MODULE_SELECTED', payload: this.get(id) });

    static hasAdditionalFields = (type) => [ModuleTypeEnum.PRODUCT, ModuleTypeEnum.TEAM, ModuleTypeEnum.ATTENDEE].indexOf(type) > -1;
}

export default ModuleHelper;